import apiClient from '../axios';

export const leavePolicyService = {
  // POST /leave-types
  createLeavePolicy: async (data) => {
    const response = await apiClient.post('/leave-configuration', data);
    return response.data;
  },

    // PATCH /leave-types/:id
  getLeavePolicy: async (id, data) => {
    const response = await apiClient.patch(`/leave-configuration/${id}`, data);
    return response.data;
  },

  // PATCH /leave-types/:id
  updateLeavePolicy: async (id, data) => {
    const response = await apiClient.patch(`/leave-configuration/${id}`, data);
    return response.data;
  },

  // DELETE /leave-types/:id
  deleteLeavePolicy: async (id) => {
    const response = await apiClient.delete(`/leave-configuration/${id}`);
    return response.data;
  }
};